<script setup lang="ts">
import { Property } from "~/classes/entity"

const props = defineProps({
  file: null
})
const container = useTemplateRef("container")
const height = computed(() => container.value?.getBoundingClientRect().height ?? 0)
const width = computed(() => container.value?.getBoundingClientRect().width ?? 0)
const { state: viewModeState } = useViewMode()

const properties = computed(
  () => viewModeState
    .value
    .current
    .show
    .filter(p => p.propertyId !== Property.FILE_VIRTUAL_PREVIEW)
    .filter(p => props.file.hasProperty(p.propertyId)),
)
const showProperties = computed(() => viewModeState.value.current.galleryView.properties)
</script>

<template>
  <div class="root">
    <div
      ref="container"
      class="gallery-file-container"
    >
      <file-thumbnail
        v-if="height"
        :file
        :container-width="width"
        :container-height="height"
        class="gallery-file-thumbnail"
      />
      <div v-if="showProperties" class="properties">
        <div
          v-for="{ propertyId, size, color } in properties"
          :key="propertyId"
          class="peek-file-property"
        >
          <file-property-view
            :property-id
            :size
            :file
            :color
            text-alignment="left"
            bg
            multiline
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.root
  @apply py-[#{$page-gallery-py-preview}] px-[#{$page-gallery-px-preview}]
.gallery-file-container
  @apply flex items-center justify-center w-full h-full relative

.properties
  max-width: max(30vw, 387px)
  @apply absolute top-0 left-0 p-[#{$page-peek-gap-item}]
  @apply z-gesture-layer
</style>
